
export const closeModalAndValidate = (handleNavBarVisiblity, sizeSettings) => {
  validateOption(sizeSettings);
  handleNavBarVisiblity(false);
}

export const validateOption = (sizeSettings, sizeOption = "OLD") => {
  const measurementOptions = sizeOption == "OLD" 
    ? sizeSettings.measurementOptions()
    : sizeSettings.measurementOptionsV2;
  const standardSizeData = sizeSettings.standardSizeData();
  const measurementStatus = sizeSettings.measurementStatus();
  const measurements = sizeSettings.diyData().measurements;
  const errorMessage = sizeSettings.errorMessage();
  const handleErrorMessage = sizeSettings.handlers.handleErrorMessage;

  switch (measurementOptions.selected) {
    case 'measure-it-yourself':
      if (isDIYMeasurementsAreValid(measurements, measurementStatus, MEAS_VALIDATION_STATUS)) {
        handleErrorMessage('');
      }
      break;
    case 'standard-size':
      if (isStandardSizeValuesProvided(standardSizeData)) {
        handleErrorMessage('');
      }
      break;
    default:
      handleErrorMessage('');
      break;
  }
}

export const getInvalidSSMeasurements = (measurementsObj) => {
  const invalidMeasurements = [];

  Object.values(measurementsObj)?.forEach(measurementObj => {
    const { selected, label } = measurementObj;

    if (selected?.trim()?.length === 0) {
      invalidMeasurements.push(label);
    }
  })

  return invalidMeasurements;
}

export const getInvalidStandardSizes = (standardSizeData) => {
  const { anchorGraded, nonAnchorGraded, nonAnchorUngraded } = standardSizeData.measurements;

  const invalidMeasurements = [
    ...getInvalidSSMeasurements(anchorGraded),
    ...getInvalidSSMeasurements(nonAnchorGraded),
    ...getInvalidSSMeasurements(nonAnchorUngraded)
  ]

  return invalidMeasurements;
}

export const isStandardMeasurementsSelectedEmpty = (measurementsObj) => {
  for (const value of Object.values(measurementsObj)) {
    if (value.selected?.trim()?.length == 0) {
      return true;
    }
  }

  return false;
}

export const isStandardSizeValuesProvided = (standardSizeData) => {
  const { anchorGraded, nonAnchorGraded, nonAnchorUngraded } = standardSizeData.measurements;

  if (
    isStandardMeasurementsSelectedEmpty(anchorGraded) ||
    isStandardMeasurementsSelectedEmpty(nonAnchorGraded) ||
    isStandardMeasurementsSelectedEmpty(nonAnchorUngraded)
  ) {
    return false;
  }

  return true;
}

export const isDIYMeasurementsAreValid = (measurements, measurementStatus, MEAS_VALIDATION_STATUS) => {
  for (const [key, status] of Object.entries(measurementStatus)) {
    if (!measurements[key].isEnabled) continue;

    if (status != MEAS_VALIDATION_STATUS.VALID) {
      return false;
    }
  }

  return true;
}

export const getInvalidDIYMeasurements = (measurements, measurementStatus, MEAS_VALIDATION_STATUS) => {
  const invalidMeasurements = [];

  for (const [key, status] of Object.entries(measurementStatus)) {
    if (!measurements[key].isEnabled) continue;

    if (status != MEAS_VALIDATION_STATUS.VALID) {
      invalidMeasurements.push(measurements[key].label);
    }
  }

  return invalidMeasurements;
}